import React from 'react';

export default ({ infoList, informationText }) => (
    <div id={'information'}>
        <div
            id={'informationTitle'}
            dangerouslySetInnerHTML={{ __html: informationText }}
        />
        <div id={'infoTag'}>
            <div id={'infoImg'}>
                <img src={'/images/userPage/desktop/page2/1.jpg'} alt />
            </div>
            <div id={'infoText'}>
                {infoList.map((info, index) => (
                    <div className={'infoList'} key={index}>- {info}</div>
                ))}
            </div>
        </div>
    </div>
);
